export enum SORT_DIRECTION {
  ASC = 'asc',
  DESC = 'desc',
}

export enum PUBLICATION_LIST_COLUMN {
  NSN = 'nsn',
  LOCATION_NAME = 'locationName',
  STATUS = 'status',
  TIME_ZONE = 'timeZone',
  PUBLICATION_DATE = 'publicationDate',
  LAST_MODIFIED = 'modified_at',
}

export enum PUBLICATION_STATUS {
  UP_TO_DATE = 'UP_TO_DATE',
  UPDATE_IN_PROGRESS = 'UPDATE_IN_PROGRESS',
  OUT_OF_DATE = 'OUT_OF_DATE',
  UP_TO_DATE_OFFLINE = 'UP_TO_DATE_OFFLINE',
  ONLINE = 'UP_TO_DATE|UPDATE_IN_PROGRESS',
  OFFLINE = 'UP_TO_DATE_OFFLINE|OUT_OF_DATE',
}

export enum STATUS_LIST {
  UP_TO_DATE = 'Up to date',
  UPDATE_IN_PROGRESS = 'Update in progress',
  UP_TO_DATE_OFFLINE = 'Up to date offline',
  OUT_OF_DATE = 'Out of date',
  ONLINE = 'Online',
  OFFLINE = 'Offline',
  FAILED = 'Failed',
}

export interface IPublicationList {
  nsn: string;
  locationName: string;
  status: string;
  timeZone: string;
  publicationDate: string;
  modified_at: string;
  locationReported: string | null;
  systemStatus: string;
}
